define(function (require){
    "use strict";

    var LPTModel        = require('vendor/Backbone/LPTModel');
    var AppConfig       = require('config/application');

    return LPTModel.extend({
        defaults: {
            tasks: [],
            calls: [],
            notifications: []
        },

        urlRoot : function(){ return AppConfig.host + '/rest/system/header'; },

        parse : function (response){
            if(response.status !== 1) {
                alert('Вы потеряли авторизацию.');
                return;
            }

            if(typeof response.result != 'undefined'){
                return response.result.data;
            }else{
                return response;
            }
        }
    });
});